import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AuthProvider from "./Components/AuthContext/AuthContext";
import Dashboard from "./Components/Users/Dashboard/Dashboard";
import Details_Page from "./Components/Users/Rent Module/Details_Page";
import Vendor_Registration from "./Components/Users/Post Module/Vendor_Registration";
// import Property_Map from "./Components/Users/BuyModuleNew/Buy_Property_map";
import Property_Map from "./Components/Users/Buy Module/Buy_Propertymap";
import Saved_Buy from "./Components/Users/Buy Module/Savedbuy";
import Constructions from "./Components/Users/Dashboard/Constructions";
import Interiors from "./Components/Users/Dashboard/Interiors-Our-Services";
import ExploreConstructionResources from "./Components/Users/Dashboard/ExploreConstructionResources";
import PostYourBestDeal from "./Components/Users/Post Module/Form-PostYourBestDeal";
import LeaseForm from "./Components/Users/Post Module/Form-Lease";
import SellYourProperty from "./Components/Users/Post Module/Form-SellYourProperty";
import Lease_map from "./Components/Users/Lease Module/Lease_map";
import Lease_detail from "./Components/Users/Lease Module/Lease_details";

import RentForm from "./Components/Users/Post Module/Rent_form";
import InteriorConsultationForm from "./Components/Users/Dashboard/Get_started";
import Footer from "./Components/Users/hemanth/Hemanth";
import Vendorsample from "./Components/Users/hemanth/VendorForm";
import Vendorsampledata from "./Components/Users/hemanth/Vendordata";
import TwodPlansInterior from "./Components/Users/Dashboard/TwodPlansInterior";
import ThreedPlansInterior from "./Components/Users/Dashboard/ThreedPlansInterior";
import Elevations from "./Components/Users/Dashboard/Elevations";
import Packages from "./Components/Users/Dashboard/Packages";
import HowItWorks from "./Components/Users/Dashboard/HowItWorks";
import Lease_discription from "./Components/Users/Lease Module/Lease_description";

import HotProperitiesMap from "./Components/Users/Dashboard/HotProperitiesMap";
import HotProperties_description from "./Components/Users/Dashboard/HotProperties_description";
import Hot_Property_Details from "./Components/Users/Dashboard/HotProperty_Details";
import HotProperty_Saves from "./Components/Users/Dashboard/HotProperty_Saves";

import Rent_Property_Map from "./Components/Users/Rent Module/Rent_Propertymap";

import Rent_description from "./Components/Users/Rent Module/Rent_description";
import Forms from "./Components/Users/Post Module/Forms";
import LeaseSave from "./Components/Users/Lease Module/LeaseSave";
import RentSaves from "./Components/Users/Rent Module/Rent_Saves";
import Login from "./Components/auth/Login";
import Register from "./Components/auth/Register";
import HomeService from "./Components/Users/Home Services/HomeService";
import WorkerDetails from "./Components/Users/Home Services/WorkerDetails";
import InboxList from "./Components/Users/Home Services/InboxList";
import WorkerDetail from "./Components/Users/Home Services/WorkerDetail";

import Buy_Property_Map from "./Components/Users/Buy Module/Buy_Propertymap";
import Buy_description from "./Components/Users/Buy Module/Buy_description";
import Buy_Details_Page from "./Components/Users/Buy Module/Details_Page";
import BuySaves from "./Components/Users/Buy Module/Buy_Saves";
import Buy_Postdeal from "./Components/Users/Buy Module/Buy_Postdeal";
import Buy_Posttable from "./Components/Users/Buy Module/Buy_Posttable";
import W_Buy from "./Components/Users/Woker/W_Buy";
import W_Lease from "./Components/Users/Woker/W_Lease";
import W_Rent from "./Components/Users/Woker/W_Rent";
import W_Vendors from "./Components/Users/Woker/W_Vendors";
import W_Post from "./Components/Users/Woker/W_Post";
import W_Navbar from "././Components/Users/Woker/W_Navbar";
import Wishlist from "./Components/Users/Wishlist/Wishlist";
import Wishlisttwo from "./Components/Users/Wishlist/Wishlisttwo";
import Three from "./Components/Users/Wishlist/Three";

import AdminLogin from "./Components/Admin/Login/Login";
import AdminDashboard from "./Components/Admin/Dashboard/Dashboard";
import AdminUploadProperties from "./Components/Admin/AdminUploadedProperties/AdminUploadProperties";
import AdminTwoDPlans from "./Components/Admin/TwoDPlans/TwoDPlans";
import AdminThreeDPlans from "./Components/Admin/ThreeDPlans/ThreeDPlans";
import AdminPackages from "./Components/Admin/Packages/Packages";
import AdminExploresConstructions from "./Components/Admin/ExploresConstruction/ExploresConstruction";
import AdminElevation from "./Components/Admin/Elevations/Elevations";
import AdminCustomers from "./Components/Admin/Customers/Customers";
import AdminBestDeals from "./Components/Admin/BestDeals/BestDeals";
import FormsBottomNavbar from "./Components/Users/Post Module/FormsBottomNavbar";
import SampleBottomNavbar from "./Components/Users/Lease Module/SampleButtomNavbar";
import ConstructionGetStarted from "./Components/Users/Dashboard/ConstructionGetStarted";
import Category from "./Components/Admin/AdminUploadedProperties/Addcategory";
import Material from "./Components/Admin/AdminUploadedProperties/Material";

// import CustomerList from "../src/Components/Admin/View/Customers"
import AdminUploadPropertiesForm from "./Components/Admin/AdminUploadedProperties/AdminUploadPropertiesForm";
import AdminUploadPropertiesTable from "./Components/Admin/AdminUploadedProperties/AdminUploadPropertiesTable";

import MapWithPoints from "./Components/Users/hemanth/MapWithPoints";

import UserBuy from "./Components/Users/Userproperties/Buy/Buy";
import UserRent from "./Components/Users/Userproperties/Rent/Rent";
import UserLease from "./Components/Users/Userproperties/Lease/Lease";
import UserVendor from "./Components/Users/Userproperties/Vendor/Vendor";
import UserBestdeals from "./Components/Users/Userproperties/BestDeals/Bestdeals";
import Portfolio from "./Components/Users/Lease Module/Portfolio";
import HomeServiceCategory from "./Components/Users/Home Services/HomeServicesCategory";
import Consultant_Table from "./Components/Admin/AdminUploadedProperties/Consultant_Table";
import EditLeaseForm from "./Components/Users/Userproperties/Lease/EditLease";
import EditRentForm from "./Components/Users/Userproperties/Rent/EditRent";
import EditBuy from "./Components/Users/Userproperties/Buy/EditBuy";
import Chat from "./Components/Users/Chat/Chat";
import ChatWindow from "./Components/Users/Home Services/IndividulChat";
import HomeServiceType from "./Components/Users/Dashboard/HomeServiceType";
import SendNotificationForm from "./SendNotification";
import EditProfile from "./Components/Users/Home Services/EditProfile";
import Email from "./Email";
import UserProfile from "./Components/Users/Home Services/UserProfile";

import Interiorstwod from "./Components/Interiors/Interiorstwod";
import Interiorsthreed from "./Components/Interiors/Interiorsthreed";
import NewBuildingsMap from "./Components/Users/NewBuildings/NewBuildingsMap";
import NewBuildingsSaves from "./Components/Users/NewBuildings/NewBuildingsSaves";
import NewBuildingsList from "./Components/Users/NewBuildings/NewBuildingsList";
import NewBuildingsDescription from "./Components/Users/NewBuildings/NewBuildingsDescription";
import TwoDplansInteriors from "./Components/Admin/TwoDplansInteriors/TwoDinterior";
import ThreeDplansInteriors from "./Components/Admin/ThreeDplansInteriors/ThreeDInterior";
import AdminProperty from "./Components/Admin/Properties/AdminProperty";
import AddProperty from "./Components/Admin/Properties/AddProperty";
import AdminInbox from "./Components/Admin/Chat/Inbox";
import AdminChat from "./Components/Admin/Chat/Chat";
import ForgotPassword from "./Components/auth/ForgotPassword";
import EditProperty from "./Components/Admin/Properties/EditProperty";
import Buy2 from "./Components/Users/Buy Module/Buy2";
import Buy3 from "./Components/Users/Buy Module/Mapsnew";
import WishlistUsersPage from "./Components/Users/Userproperties/WishlistUsersPage";
import MatchingBuyersPage from "./Components/Users/Userproperties/MatchingBuyersPage";
import AdminSubscription from "./Components/Admin/Subscription/AdminSubscription";
import UserSubscriptionPanel from "./Components/Users/Home Services/Subscriptions/UserSubscription";
// import MapWithCustomMarkers from "./Mapsnew";
import MapWithCustomMarkers from "./Components/Users/Buy Module/ZoomEffect";
import Termsandconditions from "./Components/Legal/Termsandconditions";
import Refundpolicy from "./Components/Legal/Refundpolicy"; 
import Privacypolicy from "./Components/Legal/Privacypolicy";
import Modalpopup from "./Components/CustomerInterestForm";
import { useLocation } from "react-router-dom";
import VendorEdit from "./Components/Users/Userproperties/Vendor/EditVendor";
import DisplayUserProperties from "./Components/Admin/DisplayUserProperties/DisplayUserProperties";
import EditBestDealProperty from "./Components/Users/Userproperties/BestDeals/EditBestDeal";
import ForceLoginPage from "./Components/auth/ForceLogin";
import ViewlistPage from "./Components/Users/Userproperties/ViewlistPage";
import AdminForceLoginPage from "./Components/Admin/Login/AdminForceLogin";
import Payment from "./Payment";
import NotificationDetails from "./Components/Users/Dashboard/NotificationDetails";
import AdminRequests from "./Components/Admin/AdminRequests/AdminRequests";

import PGRoom from "./Components/Users/Post Module/PGRoom";
import BuilderRequest from "./Components/Users/Post Module/BuilderRequest"
import PostBank from "./Components/Users/Post Module/PostBank"
import OnePage from "./Components/Users/Dashboard/WantedProperties";
import AllResponsesPage from './Components/Users/Dashboard/AllResponsesPage';

import SecondPage from "./Components/Users/Dashboard/Jvjd";
import PostBankcard from "./Components/Users/Post Module/PostBankcard";
import BankActionProperties from "./Components/Admin/BankActionProperties/BankActionProperties";
import WantedProperties from "./Components/Admin/Wanted-properties/Wantedproperties";
import User_BankAuction from "./Components/Admin/User-BankAuction/User_BankAuction";
import BuiltSuitProperties from "./Components/Admin/BuiltSuit_Properties/BuiltSuitProperties";
import User_BankAuction_detail from "./Components/Admin/User-BankAuction/User_BankAuction_detail";
import Bank_auction_description from "./Components/Users/Post Module/Bank_auction_description";
import Post_Bankcard_indetail from "./Components/Users/Post Module/Post_Bankcard_indetail";
import PropertySearchFilters from './Components/Users/Dashboard/PropertySearchFilters';
import PropertyResults from './Components/Users/Dashboard/PropertyResults';
import DeleteAccountConfirm from "./Components/Users/Home Services/DeleteAccountConfirm";
import WantedPropDetails from "./Components/Admin/Wanted-properties/WantedPropDetails";
import PostBank_detail from "./Components/Users/Post Module/PostBank_detail";
import JDJVPropertyDetail from "./Components/Users/Dashboard/JDJVPropertyDetail";
import Buy_map from "./Components/Users/Buy Module/Buy_map";

import AdminWantedPropertys from "./Components/Admin/WantedProperty/WantedProperty";
import AdminJVJD from "./Components/Admin/JVJD/Jvjd";
import SuccessAlert from "./Components/Users/Alertpage/SuccessAlert/SuccessAlert";
import FailureAlert from "./Components/Users/Alertpage/FailureAlert/FailureAlert";
import CopyFailureAlert from "./Components/Users/Alertpage/CopyAlert/CopyFailureAlert";
import DeleteSuccessAlert from "./Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert";
import DeleteFailureAlert from "./Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert";
import WishlistSuccessAlert from "./Components/Users/Alertpage/CopyAlert/WishlistSuccessAlert";
import WishlistRemovedAlert from "./Components/Users/Alertpage/CopyAlert/WishlistRemovedAlert";
import WishlistNotRemovedAlert from "./Components/Users/Alertpage/CopyAlert/WishlistNotRemovedAlert";
import ShareCopySuccessAlert from "./Components/Users/Alertpage/ShareAlert/ShareCopySuccessAlert";
import ShareCopyFailureAlert from "./Components/Users/Alertpage/ShareAlert/ShareCopyFailureAlert";
import CopySuccessAlert from "./Components/Users/Alertpage/CopyAlert/CopySuccessAlert";
import BoostSuccessAlert from "./Components/Users/Alertpage/CopyAlert/BoostAlert";
import BoostFailureAlert from "./Components/Users/Alertpage/CopyAlert/BoostFailureAlert";
import VerifyEmailPage from "./Components/auth/VerifyEmailPage";
import CustomersLoginHistory from "./Components/Admin/Customers/CustomersLoginHistory";
import Index from "./Components/Users/TestMapSell/Index";

import RentIndex from "./Components/Users/TestMapRent/RentIndex";
import LeaseIndex from "./Components/Users/TestMapLease/LeaseIndex";
import Jvjdindex from "./Components/Users/TestMapjvjd/JvjdIndex";
import AuctionIndex from "./Components/Users/TestAuctionmap/AuctionIndex";
import BestdealIndex from "./Components/Users/TestBestdealmap/BestdealIndex";
import PrimeIndex from "./Components/Users/TestMapprime/PrimeIndex";
import PaintingIndex from "./Components/Users/TestMappainting/PaintingIndex";
import TestmapcategoryIndex from "./Components/Users/TestMapAllCategory/TestmapcategoryIndex";


  
function App() {
  useEffect(() => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        const { route, section } = event.data;
        if (route) {
          window.location.href = `${route}?section=${section}`;
        }
      });
    }
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const currentPath = location.pathname;
  console.log('Current path:', currentPath); // Debug current path
  console.log('Path in lowercase:', currentPath.toLowerCase());

  const excludedPrefixes = [
    '/',
    '/login',
    '/admin-dashboard',
    '/adminuploadproperties',
    '/admin-2dplans',
    '/admin-3dplans',
    '/admin-packages',
    '/admin-explore-constructions',
    '/admin-elevation',
    '/admin-customers',
    '/admin-customers-login-history',
    '/admin-bestdeals',
    '/adminuploadpropertiesform',
    '/admin-properties',
    '/a-add-property',
    '/admin-material',
    '/admin-addcategory',
    '/Consultant_Table',
    '/twoD-interior',
    '/threeD-interior',
    '/admin-inbox',
    '/Forgot',
    '/admin-subscription',
    '/display-user-properties',
    '/admin-request',
    '/admin-bank-action-props',
    '/admin-jvjd',
    '/admin-wanted',
    '/register',
    '/termsandconditions',
    '/refundpolicy',
    '/privacypolicy',
  ];
 const shouldShowModal = !excludedPrefixes.some(prefix => 
    currentPath === prefix || 
    currentPath.startsWith(`${prefix}/`) 
  );
 console.log('Should show modal?', shouldShowModal); 

  return (
   <>
    {shouldShowModal && <Modalpopup />}
    {/* <Modalpopup /> */}
      <Routes>

  
       
          <Route path="/" element={<Login />} />
          <Route path="/termsandconditions" element={<Termsandconditions/>} />
          <Route path="/refundpolicy" element={<Refundpolicy/>} />
          <Route path="/privacypolicy" element={<Privacypolicy/>} />
          {/* <Route path="/modalpopup" element={<Modalpopup/>} /> */}


          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/notification-details" element={<NotificationDetails />} />

          {/* Tharun */}
          {/* <Route path="/home-service" element={<HomeService />} /> */}
           <Route path="/home-service" element={<TestmapcategoryIndex />} />
          <Route path="/work-details" element={<WorkerDetails />} />
          <Route path="/work-details/:id" element={<WorkerDetails />} />
          <Route path="/inboxlist" element={<InboxList />} />
          <Route path="/work-detail" element={<WorkerDetail />} />
          <Route path="/post" element={<Forms />} />
           <Route path="/user-subscription" element={<UserSubscriptionPanel />} />
          <Route path="/details" element={<Details_Page />} />
          <Route path="/postyourbestdeal-form" element={<PostYourBestDeal />} />
          <Route path="/lease-form" element={<LeaseForm />} />
          <Route path="/sellyourproperty-form" element={<SellYourProperty />} />
          <Route path="/vendor-form" element={<Vendor_Registration />} />
          <Route path="/propertymap" element={<Property_Map />} />
          <Route path="/Savedbuy" element={<Saved_Buy />} />
          <Route path="/constructions" element={<Constructions />} />
          <Route path="/interiors" element={<Interiors />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/user-profile/:userId" element={<UserProfile />} />
          <Route path="/delete-account/:id" element={<DeleteAccountConfirm />} />


          <Route
            path="/construction-get-started"
            element={<ConstructionGetStarted />}
          />
          <Route
            path="/explore-construction-resources"
            element={<ExploreConstructionResources />}
          />
          <Route path="/two-d-plane-interior" element={<TwodPlansInterior />} />
          <Route path="/interiorstwod" element={<Interiorstwod />} />
          <Route path="/interiorsthreed" element={<Interiorsthreed />} />
          <Route
            path="/three-d-plane-interior"
            element={<ThreedPlansInterior />}
          />
          <Route path="/elevations" element={<Elevations />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          {/* <Route path="/hot-property-map" element={<HotProperitiesMap />} /> */}
          <Route path="/hot-property-map" element={<BestdealIndex />} />
          {/* <Route
            path="/hot-property-description"
            element={<HotProperties_description />}
          /> */}
           <Route
            path="/hot-property-description/:propertyId"
            element={<HotProperties_description />}
          />
          <Route
            path="/hot-property-details"
            element={<Hot_Property_Details />}
          />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/hot-property-saves" element={<HotProperty_Saves />} />
          {/* <Route path="/lease_map" element={<Lease_map />} /> */}
           <Route path="/lease_map" element={<LeaseIndex />} />
          <Route path="/lease_details" element={<Lease_detail />} />
          <Route
            path="/lease_description/:id"
            element={<Lease_discription />}
          />
          <Route path="/lease_description" element={<Lease_discription />} />
          <Route path="/lease-description" element={<Lease_discription />} />
                    <Route path="/lease-description/:propertyId" element={<Lease_discription />} />

          <Route path="/lease_save" element={<LeaseSave />} />
          <Route path="/lease_nav" element={<FormsBottomNavbar />} />
          <Route path="/lease_sampleNavbar" element={<SampleBottomNavbar />} />
          <Route path="/rent-form" element={<RentForm />} />
          <Route path="/get-started" element={<InteriorConsultationForm />} />
          <Route path="/Footer" element={<Footer />} />
          <Route path="/samplevendor" element={<Vendorsample />} />
          <Route path="/samplevendordata" element={<Vendorsampledata />} />
          <Route path="/rent-description" element={<Rent_description />} />
            <Route path="/rent-description/:propertyId" element={<Rent_description />} />
          {/* <Route path="/rent-propertymap" element={<Rent_Property_Map />} /> */}
          <Route path="/rent-propertymap" element={<RentIndex />} />

          <Route path="/rent-saves" element={<RentSaves />} />
          <Route path="/Buy-propertymap" element={<Buy_Property_Map />} />
<Route path="/Buy-description" element={<Buy_description />} />
<Route path="/Buy-description/:propertyId" element={<Buy_description />} /> {/* This is correct now */}
          <Route path="/Buy-details" element={<Buy_Details_Page />} />
          <Route path="/Buy-saves" element={<BuySaves />} />
          <Route path="/Buy-Postdeal" element={<Buy_Postdeal />} />
          <Route path="/Buy-Posttable" element={<Buy_Posttable />} />
          <Route path="/W_Buy" element={<W_Buy />} />
          <Route path="/W_Lease" element={<W_Lease />} />
          <Route path="/W_Rent" element={<W_Rent />} />
          <Route path="/W_Vendors" element={<W_Vendors />} />
          <Route path="/W_Post" element={<W_Post />} />
          <Route path="/W_Navbar" element={<W_Navbar />} />
          <Route path="/map" element={<MapWithPoints />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/wishlisttwo" element={<Wishlisttwo />} />
          <Route path="/force-login" element={<ForceLoginPage />} />
           <Route path="/admin-force-login" element={<AdminForceLoginPage />} />
          <Route path="/three" element={<Three />} />
          
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route
            path="/adminuploadproperties"
            element={<AdminUploadProperties />}
          />
          <Route path="/admin-2dplans" element={<AdminTwoDPlans />} />
          <Route path="/admin-3dplans" element={<AdminThreeDPlans />} />
          <Route path="/admin-packages" element={<AdminPackages />} />
          <Route
            path="/admin-explore-constructions"
            element={<AdminExploresConstructions />}
          />
          <Route path="/admin-elevation" element={<AdminElevation />} />
          <Route path="/admin-customers" element={<AdminCustomers />} />
           <Route path="/admin-customers-login-history" element={<CustomersLoginHistory />} />
             <Route path="/admin-subscription" element={<AdminSubscription />} />
          <Route path="/admin-bestdeals" element={<AdminBestDeals />} />
          <Route path="/admin-properties" element={<AdminProperty />} />
           <Route path="/admin-bank-action-props" element={<BankActionProperties />} />
           <Route path="/display-user-properties" element={<DisplayUserProperties />} />
          <Route path="/a-add-property" element={<AddProperty />} />
          <Route path="admin-edit-property/:menuPropertyId" element={<EditProperty />} />
          <Route path="/admin-material" element={<Material />} /> 
          <Route path="/admin-addcategory" element={<Category />} /> 
          <Route path="/Consultant_Table" element={<Consultant_Table />} /> 

          {/* <Route path="/view" element={<CustomerList />} /> */}
          <Route
            path="/adminuploadpropertiesform"
            element={<AdminUploadPropertiesForm />}
          />
          {/* <Route path="/adminuploadpropertiestable" element={<AdminUploadPropertiesTable />} /> */}
          <Route path="/user-buy" element={<UserBuy />} />
          <Route path="/user-rent" element={<UserRent />} />
          <Route path="/user-lease" element={<UserLease />} />
          <Route path="/user-bestdeals" element={<UserBestdeals />} />
          <Route path="/user-vendors" element={<UserVendor />} />
          <Route path="/wishlist-users/:propertyId" element={<WishlistUsersPage />} />
          <Route path="/matching-buyers/:propertyId" element={<MatchingBuyersPage />} />

          <Route path="/home-service-category" element={<HomeServiceCategory />} />
          <Route path="/user-edit-lease/:menuPropertyId" element={<EditLeaseForm />} />
          <Route path="/user-edit-rent/:menuPropertyId" element={<EditRentForm />} />
          <Route path="/user-edit-buy/:menuPropertyId" element={<EditBuy />} />
          <Route path="/user-edit-bestdeal/:menuPropertyId" element={<EditBestDealProperty />} />
           <Route path="/user-edit-vendor/:vendorId" element={<VendorEdit />} />

          <Route path="/chat" element={<Chat />} />
          <Route path="/chat/:propertyId/:customerid" element={<ChatWindow />} />
          <Route path="/wanted-properties" element={<OnePage />} />
          <Route path="/all-responses" element={<AllResponsesPage />} />

          {/* <Route path="/jvjd" element={<SecondPage />} /> */}
          <Route path="/jvjd" element={<Jvjdindex />} />

          {/* <Route path="/home-service-type" element={<HomeServiceType />} /> */}
            <Route path="/home-service-type" element={<PaintingIndex />} />
          <Route path="/notification" element={<SendNotificationForm />} />
          <Route path="/email" element={<Email />} />
          {/* <Route path="/new-map" element={<NewBuildingsMap />} /> */}
             <Route path="/new-map" element={<PrimeIndex />} />
          <Route path="/new-saves" element={<NewBuildingsSaves />} />
          <Route path="/new-list" element={<NewBuildingsList />} />
          <Route path="/new-description/:propertyId" element={<NewBuildingsDescription />} />
          <Route path="/twoD-interior" element={<TwoDplansInteriors />} />
          <Route path="/threeD-interior" element={<ThreeDplansInteriors />} />
          <Route path="/admin-inbox" element={<AdminInbox />} />
          <Route path="/admin-Chat/:propertyId/:customerid" element={<AdminChat />} />
           <Route path="/Forgot" element={<ForgotPassword />} />
           <Route path="/buy2" element={<Buy2 />} />
           <Route path="/buy3" element={<Buy3 />} />
          <Route path="/mapWithCustomMarkers" element={<MapWithCustomMarkers />} />
          <Route path="/viewlistpage/:propertyId" element={<ViewlistPage />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/admin-request" element={<AdminRequests />} />

          <Route path="/pg-hostel-form" element={<PGRoom />} />
          <Route path="/builder-registration-form" element={<BuilderRequest />} />

          <Route
  path="/wanted-prop-details/:req_id"
  element={<WantedPropDetails />}
/>


          <Route path="/post-bank-properties" element={<PostBank />} />
          {/* <Route path='/postbank-card' element={<PostBankcard />} /> */}
              <Route path='/postbank-card' element={<AuctionIndex />} />
          <Route path="/user-wanted" element={< WantedProperties />} />
            <Route path="/user-bankauction" element={<User_BankAuction />} />
<Route path="/User_BankAuction_detail/:id" element={<User_BankAuction_detail />} />
            <Route path="/builtSuitProperties" element={<BuiltSuitProperties />} />
<Route path="/User_BankAuction_detail" element={<User_BankAuction_detail />} />
<Route path="/bank-auction-description/:id" element={<Bank_auction_description />} />
<Route path="/bank-auction-description" element={<Bank_auction_description />} />
<Route path="/Post_Bankcard_indetail" element={<Post_Bankcard_indetail />} />
<Route path="/Post_Bankcard_indetail/:id" element={<Post_Bankcard_indetail />} />
          <Route path="/property-search" element={<PropertySearchFilters />} />
<Route path="/property-results" element={<PropertyResults />} />
<Route path="/postbank_detail" element={<PostBank_detail />} />
<Route path="/jv-jv-property-detail/:id" element={<JDJVPropertyDetail />} />
{/* <Route path="/buy-map" element={<Buy_map />}/> */}
<Route path="/buy-map" element={<Index />}/>

<Route path="/success" element={<SuccessAlert />}/>
<Route path="/failure" element={<FailureAlert />}/>
<Route path="/copyfailure" element={<CopyFailureAlert />}/>
<Route path="/deletealert" element={<DeleteSuccessAlert />}/>
<Route path="/deletefailure" element={<DeleteFailureAlert />}/>
<Route path="/wishlistalert" element={<WishlistSuccessAlert />}/>
<Route path="/copysucesss" element={<CopySuccessAlert />}/>

<Route path="/wishlistfailure" element={<WishlistRemovedAlert />}/>
<Route path="/wishlistremoved" element={<WishlistNotRemovedAlert />}/>
<Route path="/sharesuccessalert" element={<ShareCopySuccessAlert />} />
<Route path="/sharefailurealert" element={<ShareCopyFailureAlert />} />
<Route path="/boostsuccesalert" element={<BoostSuccessAlert />} />
<Route path="/boostfailurealert" element={<BoostFailureAlert />} />

<Route path="/admin-wanted" element={<AdminWantedPropertys />} />
<Route path="/admin-jvjd" element={<AdminJVJD />}/>


{/* // path: "/admin-jvjd" 
      { label: "Wanted Properties", path: "/admin-wanted" }, */}



        </Routes>
     </>
  );
}

export default App;
